import { axios } from './config';

// 获取人员报警列表
export function getPersonWarningList(params) {
  return axios.post('/personWarning/list_warning', params, false)
}

// 人员报警处理
export function handlePersonWarning(params) {
  return axios.post('personWarning/dispose_warning', params, false)
}

// 到期预警-待处理作业
export function getDclzyList(params) {
  return axios.post('/workPermit/emcList', params, false)
}

// 到期预警-应急监控证书
export function getZsList(params) {
  return axios.post('/certificate/getExpire', params, false)
}

// 到期预警-应急监控待培训列表
export function getPxList(params) {
  return axios.post('/cultivate/getNotByUserId', params, false)
}

// 到期预警-应急监控待填写研判列表
export function getFxypList(params) {
  return axios.get('/researchvotedetail/getNotFill', params, false)
}

// 到期预警-应急监控待考试列表
export function getKsList(params) {
  return axios.post('/examrecord/getNotByUserId', params, false)
}

export function getCertificateExpireList(params) {
  return axios.post('/certificate/getExpire', params, false)
}

export function getHiddenGovernList(params) {
  return axios.post('/hiddenGovern/list_all', params, false)
}

// 到期预警-应急监控待巡检列表
export function getXjList(params) {
  return axios.post('/inspectionrecord/getNotByUserId', params, false)
}

// 到期预警-设备到期-维护保养到期列表
export function getSbByList(params) {
  return axios.get('/reminders/equipmentReminder', params, false)
}


// 预警报警-设备报警-获取列表
export function getEquipmentAlarm(params) {
  // return axios.post('/channelrecord/emcList', params, false)
  return axios.post('/channelrecord/list_all', params, false)
}

// 预警报警-设备报警-处理
export function handelEquipmentAlarm(params) {
  return axios.post('/channelrecord/handler', params, false)
}

// 预警报警-区域工作列表
export function getAreaWorkList(params) {
  return axios.post('/workPermit/list_working', params, false)
}

// 预警报警-区域-风险点复评列表
export function getAreaRiskPointList(params) {
  return axios.post('/riskclassification/list_next_evaluation', params, false)
}